import React from 'react';

import { TextField, Typography, Box, useTheme } from '@mui/material';

import MfsRichTextEditor from '../../components/Common/RichText/RichTextEditor';

import LocalisedDatePicker from '../../components/Common/LocalisedDatePicker';

const SetupSHowcase = ({
  setEditor,
  setIsTouched,
  setVenue,
  setDate,
  setTime,
  setLocation,
  setMetaDesc,
  setMetaKeywords,
  setMetaTitle,
  venue,
  date,
  time,
  location,
  metaDesc,
  metaKeywords,
  metaTitle,
  description,
}) => {
  const theme = useTheme();
  return (
    <>
      <Box mx={1} mt={2}>
        <TextField
          required
          id='venue'
          label='VenueName'
          value={venue}
          onChange={(event) => setVenue(event.target.value)}
          size='small'
          sx={{ mr: 1, my: 1 }}
        />
        <Box sx={{ display: 'inline-block', mr: 1, my: 1 }}>
          <LocalisedDatePicker
            views={['day']}
            label='ShowcaseDate'
            date={date}
            setDate={setDate}
          />
        </Box>
        <TextField
          required
          id='time'
          label='Times DisplayText'
          value={time}
          onChange={(event) => setTime(event.target.value)}
          size='small'
          sx={{ mr: 1, my: 1 }}
        />
        <TextField
          required
          id='location'
          label='Location'
          value={location}
          onChange={(event) => setLocation(event.target.value)}
          size='small'
          fullWidth
          sx={{ my: 1 }}
        />

        <TextField
          required
          multiline
          id='metaDesc'
          label='MetaDescription'
          value={metaDesc}
          onChange={(event) => setMetaDesc(event.target.value)}
          sx={{ my: 1 }}
          fullWidth
          InputProps={{
            rows: 1,
            multiline: true,
            inputComponent: 'textarea',
          }}
        />
        <TextField
          required
          multiline
          id='metaKeywords'
          label='MetaKeywords'
          value={metaKeywords}
          onChange={(event) => setMetaKeywords(event.target.value)}
          fullWidth
          sx={{ my: 1 }}
          InputProps={{
            rows: 1,
            multiline: true,
            inputComponent: 'textarea',
          }}
        />
        <TextField
          required
          multiline
          id='metaTitle'
          label='MetaTitle'
          value={metaTitle}
          onChange={(event) => setMetaTitle(event.target.value)}
          fullWidth
          sx={{ my: 1 }}
          InputProps={{
            rows: 1,
            multiline: true,
            inputComponent: 'textarea',
          }}
        />
      </Box>

      <Box m={1} pb={3}>
        <Typography variant='subtitle1' color={theme.palette.text.secondary}>
          Page Content
        </Typography>
        <MfsRichTextEditor
          content={description}
          setEditor={(editor) => setEditor(editor)}
          setTouched={() => setIsTouched(true)}
          isSatellite={false}
        />
      </Box>
    </>
  );
};

export default SetupSHowcase;
